$(document).ready(function () {

    var form = $("#formAssinar");

	$('#form-telefone1').mask(siteAPI.masks.dynamicPhone, siteAPI.masks.dynamicPhoneOptions);
	$('#form-telefone2').mask(siteAPI.masks.dynamicPhone, siteAPI.masks.dynamicPhoneOptions);

	form.formValidation({
        // framework: 'bootstrap',
        message: 'Valor inválido',
        icon: {
            valid: 'glyphicon glyphicon-ok',
            invalid: 'glyphicon glyphicon-remove',
            validating: 'glyphicon glyphicon-refresh'
        },
        fields: {
            nome: {
                validators: {
                    notEmpty: {
                        message: 'Por favor informe o nome'
                    }
                }
            },
            telefone1: {
                validators: {
                    notEmpty: {
                        message: 'Por favor informe o telefone'
                    }
                }
            }
        }
    })
    .on('success.form.fv', function(e) {

        e.preventDefault();
        
        if(grecaptcha.getResponse().length == 0) {
            $("#recaptchaError").html('Marque a opção: Não sou um robô!');
           	$("#recaptchaError").show();
           	form.data('formValidation').disableSubmitButtons(false);
            return false;
        }

        $("#recaptchaError").hide();

        var url = form.attr('action');

        $.ajax({
          url: url,
          method: "POST",
          dataType: 'json',
          data : form.serialize(),
        })
        .done(function( data ) {
            form.data('formValidation').resetForm(true);
        })
        .fail(function( data ) {
            form.data('formValidation').resetForm(false);
        })
        .always(function() {
            grecaptcha.reset();
        });

    });
});